export const gallery = [
  {
    id: "gal-1",
    title: "Пластиковые окна",
    text: "Равным образом сложившаяся структура организации",
    imgDesk1: "./img/works-1-desktop.jpg",
    imgDesk2: "./img/works-1-desktop@2x.jpg",
    img1: "./img/works-1.jpg",
    img2: "./img/works-1@2x.jpg",
  },
  {
    id: "gal-2",
    title: "Балконные рамы",
    text: "Равным образом сложившаяся структура организации",
    imgDesk1: "./img/works-2-desktop.jpg",
    imgDesk2: "./img/works-2-desktop@2x.jpg",
    img1: "./img/works-2.jpg",
    img2: "./img/works-2@2x.jpg",
  },
  {
    id: "gal-3",
    title: "Пластиковые перегородки",
    text: "Равным образом сложившаяся структура организации",
    imgDesk1: "./img/works-3-desktop.jpg",
    imgDesk2: "./img/works-3-desktop@2x.jpg",
    img1: "./img/works-3.jpg",
    img2: "./img/works-3@2x.jpg",
  },
  {
    id: "gal-4",
    title: "Алюминевые конструкции",
    text: "Равным образом сложившаяся структура организации",
    imgDesk1: "./img/works-4-desktop.jpg",
    imgDesk2: "./img/works-4-desktop@2x.jpg",
    img1: "./img/works-4.jpg",
    img2: "./img/works-4@2x.jpg",
  },
  {
    id: "gal-5",
    title: "Фасады",
    text: "Равным образом сложившаяся структура организации",
    imgDesk1: "./img/works-5-desktop.jpg",
    imgDesk2: "./img/works-5-desktop@2x.jpg",
    img1: "./img/works-5.jpg",
    img2: "./img/works-5@2x.jpg",
  },
];
